import { FC } from 'react'
import { KeyResultInput } from '../../../../types'
import { Checkbox } from 'antd'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerText from '../../../../components/custom_components/Text'

interface Props {
  keyResult: KeyResultInput
}
export const ViewKeyResultItem: FC<Props> = ({ keyResult }) => (
  <PerFlexRow my="xs" className="keyResultItem">
    <Checkbox disabled checked={keyResult.completed}>
      <PerText appearance="flowing-text" display="inline">
        {keyResult.text}
      </PerText>
    </Checkbox>
  </PerFlexRow>
)
